import { colors } from "./Colors";
import { fontWeight } from "./Fonts";

export const theme = {
  colors: colors,
  fontWeight: fontWeight
}